export { default } from "./saga";



// WEBPACK FOOTER //
// ./src/model/subsystems/app/saga/index.js